import React from 'react'
import styled from '@emotion/styled'
import { Tabs } from 'antd'
import { BiComparativoSemanal } from './BiComparativoSemanal'
import { BiEvolucaoDiaria } from './BiEvolucaoDiaria'
import { BiEvolucaoMensal } from './BiEvolucaoMensal'
import { BiAquisicaoParceiros } from './BiAquisicaoParceiros'
import { BiDesempenhoCursos } from './BiDesempenhoCursos'
import { BiEstados } from './BiEstados'

export function Bi() {
  return (
    <PageLayout>
      <PageTitle>BI</PageTitle>
      <Tabs
        items={[
          { key: 'semanal', label: 'Comparativo no Período', children: <BiComparativoSemanal /> },
          { key: 'diario', label: 'Evolução Diária', children: <BiEvolucaoDiaria /> },
          { key: 'mensal', label: 'Evolução Mensal', children: <BiEvolucaoMensal /> },
          { key: 'parceiros', label: 'Aquisição de Parceiros', children: <BiAquisicaoParceiros /> },
          { key: 'cursos', label: 'Desempenho por Curso', children: <BiDesempenhoCursos /> },
          { key: 'estados', label: 'Estados', children: <BiEstados /> },
        ]}
      />
    </PageLayout>
  )
}

const PageLayout = styled.div`
  padding: 20px;
  background: whitesmoke;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100%;
`

const PageTitle = styled.span`
  font-size: 22px;
  color: #494d50;
  font-weight: 600;
`
